import { inject, injectable } from "inversify";
import IOperationsHistoryService from "./IOperationsHistoryService";
import { replaceCurrencySymb } from "../../utilities/parseHelper";
import { DeclarationPropertyValueData } from "../../data/declarationPropertyValueData";
import { StatementItemModel } from "../../models/statement/statementItemModel";
import { RequestParamsModel } from "../../models/statement/requestParamsModel";
import { OperationDetailsModel } from "../../models/operations/operationDetailsModel";
import { OperationsHistoryApi } from "../api/OperationsHistoryApi";
import IAlertService from "../alert/IAlertService";
import { DiTokens } from "../diTokens";
import IErrorService from "../error/IErrorService";

@injectable()
/** Сервис истории операций */
export default class OperationsHistoryService
  implements IOperationsHistoryService {
  constructor(
    @inject(DiTokens.AlertService) private alertService: IAlertService,
    @inject(DiTokens.ErrorService) private errorService: IErrorService
  ) { }

  /** Получение списка операций */
  public async getOperationsHistory(
    params: RequestParamsModel,
    afterOperation: boolean = false
  ): Promise<Array<StatementItemModel>> {
    try {
      /** При отсутствии дат отправляем на сервер значения с 1 числа месяца по сегодняшний день */
      if (!params.dateBegin && !params.dateEnd) {
        const nowDate = new Date();
        params.dateBegin = `${nowDate.getFullYear()}-${nowDate.getMonth() + 1 < 10
            ? "0" + (nowDate.getMonth() + 1)
            : nowDate.getMonth() + 1
          }-01`;
        params.dateEnd = `${nowDate.getFullYear()}-${nowDate.getMonth() + 1 < 10
            ? "0" + (nowDate.getMonth() + 1)
            : nowDate.getMonth() + 1
          }-${nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate()
          }`;
      } else if (params.dateBegin && !params.dateEnd) {
        params.dateEnd = params.dateBegin;
      } else if (!params.dateBegin && params.dateEnd) {
        params.dateBegin = params.dateEnd;
      }

      const resData = afterOperation ? await OperationsHistoryApi.getOperationsList(params) : await OperationsHistoryApi.getOperationsHistory(params);
      const result = resData.map(
        item =>
          new StatementItemModel(
            item.Date,
            item.Picture,
            item.Description,
            item.RequestState,
            item.Sum,
            item.Currency,
            item.Category,
            item.Id,
            +item.ReferenceId,
            item.ContractAlias,
            item.IsRespondentActive
          )
      );
      if (result) return result;
    } catch (e) {
      await this.errorService.errorHandler(e, false, true, "");
    }

    return [];
  }

  public async getOperationDetails(
    operation: any
  ): Promise<OperationDetailsModel> {
    try {
      const requestData = await OperationsHistoryApi.getOperationAsync(
        operation.Id,
        operation.ReferenceId
      );
      const respondentCode = parseInt(requestData.respondentCode);
      const operationDetail = new OperationDetailsModel(operation, requestData);
      if (!isNaN(respondentCode)) {
        operationDetail.RespondentData = await OperationsHistoryApi.getRespondentAsync(
          respondentCode
        );
      }
      operationDetail.RequestData?.details.forEach(
        (d: DeclarationPropertyValueData) => {
          d.Value = replaceCurrencySymb(d.Value);
        }
      );
      if (operationDetail.RequestData?.details)
        operationDetail.Details = operationDetail.RequestData?.details;

      return operationDetail;
    } catch (e) {
      await this.errorService.errorHandler(e, false, true, "");
      throw e;
    }
    return operation;
  }

  public async getStatementFile(): Promise<any> {
    console.log("getStatementFile/No implementation");
  }
}
